import { useMutation } from "urql";

import { CreateCollateralDocument } from "../../../graphql/generated.ts";

export const useCreateCollateral = () => useMutation(CreateCollateralDocument);
